namespace $.$$ {

	export class $shm_projects_task extends $.$shm_projects_task {

		auto() {
			const run_id = this.run_id()
			if( run_id ) {
				this.task_poll_schedule()
			}
			return [ ...super.auto(), ...( run_id ? [ this.run_events().native() ] : [] ) ]
		}

		@ $mol_mem
		agent_brought( next?: boolean ) { return next ?? false }

		agent_bring_schedule() {
			if( this.agent_brought() ) return null
			this.agent_brought( true )
			return new this.$.$mol_after_frame( ()=> {
				const page = this.Agent().Chat_page().dom_node() as HTMLElement
				let book = page.parentElement
				while( book && !book.hasAttribute( 'mol_book2' ) ) book = book.parentElement
				book?.scroll({ left: page.offsetLeft + page.offsetWidth - book.clientWidth, behavior: 'smooth' })
			} )
		}

		private task_poll_timer: ReturnType< typeof setTimeout > | null = null

		task_poll_schedule() {
			if( this.task_poll_timer ) return this.task_poll_timer
			this.task_poll_timer = setTimeout( ()=> {
				this.task_poll_timer = null
				$mol_wire_async( this ).task_poll()
			}, 1000 )
			return this.task_poll_timer
		}

		task_poll() {
			const id = this.task_data().run_id
			if( !id ) return null
			const run = $mol_wire_sync( $shm_projects_goal_api ).run( id )
			this.run_receive( run )
			if( ![ 'done', 'failed', 'stopped' ].includes( run.status ) ) this.task_poll_schedule()
			return run
		}

		@ $mol_mem
		task_data( next?: $shm_projects_task_record ) {
			if( next !== undefined ) return next
			const task = this.$.$shm_projects_task_get( this.project_id(), this.task_id() )
			if( !task ) throw new Error( `Unknown task: ${ this.task_id() }` )
			return {
				...task,
				legacy_id: task.legacy_id ?? '',
				creator_id: task.creator_id ?? '',
				creator_name: task.creator_name ?? '',
				assignee_id: task.assignee_id ?? '',
				assignee_name: task.assignee_name ?? '',
				acceptance_criteria: task.acceptance_criteria ?? '',
				priority: task.priority ?? 'normal',
				revision: task.revision ?? 0,
				planned_revision: task.planned_revision ?? 0,
				mode: task.mode ?? 'research',
				pinned: task.pinned ?? false,
				archived: task.archived ?? false,
			}
		}

		@ $mol_mem
		run_live( next?: $shm_projects_goal_run | null ) { return next ?? null }

		@ $mol_mem_key
		run_initial( id: string ) {
			if( !id ) return null
			return this.$.$mol_error_fence(
				()=> $mol_wire_sync( $shm_projects_goal_api ).run( id ),
				()=> null,
				()=> null,
			)
		}

		run_data( next?: $shm_projects_goal_run | null ): $shm_projects_goal_run | null {
			if( next !== undefined ) return this.run_live( next )
			const id = this.run_id()
			if( !id ) return null
			const live = this.run_live()
			return live?.id === id ? live : this.run_initial( id )
		}

		run_id() { return this.task_data().run_id }

		@ $mol_mem
		run_events() {
			const events = new this.$.$shm_projects_goal_api_events
			events.id = ()=> this.run_id()
			events.notify = ()=> run => this.run_receive( run )
			return events
		}

		@ $mol_action
		run_receive( run: $shm_projects_goal_run ) {
			if( run.id !== this.run_id() ) return run
			this.run_data( run )
			this.task_from_run( run )
			this.Agent().refresh( this.Agent().refresh() + 1 )
			return run
		}

		@ $mol_action
		task_from_run( run: $shm_projects_goal_run ) {
			const current = this.task_data()
			const change: Partial< $shm_projects_task_record > = {
				status: run.status,
				mode: run.task_action ?? ( run.task_mode === 'plan' || run.task_mode === 'research' ? 'research' : 'work' ),
			}
			if( ( run.task_mode === 'plan' || run.task_mode === 'research' ) && run.status === 'done' ) change.planned_revision = run.task_revision ?? current.revision
			if( run.status === 'done' ) {
				const source = String( run.summary || '' ).trim()
				const result = source.match( /(?:^|\n)#{1,6}\s*Результат(?:ы)?\s*\n([\s\S]*)$/i )?.[1]?.trim()
				if( result ) change.result = result
			}
			if( Object.entries( change ).every( ( [ key, value ] )=> current[ key as keyof $shm_projects_task_record ] === value ) ) return current
			const next = this.$.$shm_projects_task_update( this.project_id(), this.task_id(), change )
			this.task_data( next )
			return next
		}

		task_page_title() { return this.task_data().title || 'Новая задача' }

		@ $mol_mem
		task_title_draft( next?: string ) { return next ?? this.task_data().title }

		description_draft( next?: string ) {
			const current = this.task_data()
			if( next === undefined || next === current.description ) return next ?? current.description
			const saved = this.$.$shm_projects_task_update(
				this.project_id(), this.task_id(), { description: next },
			)
			return saved.description
		}

		assignee_options(): Record< string, string > {
			const current = this.task_data()
			const legacy = !current.assignee_id && current.assignee_name ? `name:${ current.assignee_name }` : ''
			return {
				'': 'Не назначен',
				...( legacy ? { [ legacy ]: current.assignee_name } : {} ),
				...( current.creator_id ? { [ current.creator_id ]: current.creator_name || current.creator_id } : {} ),
				...( current.assignee_id ? { [ current.assignee_id ]: current.assignee_name || current.assignee_id } : {} ),
				... this.$.$shm_projects_users_options(),
			}
		}

		@ $mol_mem
		assignee_id_draft( next?: string ) {
			return next ?? ( this.task_data().assignee_id || ( this.task_data().assignee_name ? `name:${ this.task_data().assignee_name }` : '' ) )
		}

		@ $mol_mem
		priority_draft( next?: string ) { return next ?? this.task_data().priority ?? 'normal' }

		@ $mol_mem_key
		action_payload( key: string, next?: $shm_projects_task_record ) {
			return next ?? null
		}

		priority_options() {
			return { low: 'Низкий', normal: 'Обычный', high: 'Высокий', urgent: 'Срочный' }
		}

		creator_name() { return this.task_data().creator_name || 'Локальный пользователь' }

		@ $mol_mem
		edit_opened_state( next?: boolean | null ) {
			return next === undefined ? null : next
		}

		edit_opened( next?: boolean ) {
			if( next !== undefined ) return this.edit_opened_state( next )!
			return this.edit_opened_state() ?? !this.run_id()
		}

		task_body() { return [ this.edit_opened() ? this.Editor() : this.Summary() ] }

		editor_action_rows() {
			return [
				this.Research(),
				this.Work(),
				this.Work_prerelease(),
				...( this.run_id() ? [ this.Edit_cancel() ] : [] ),
			]
		}

		task_action_enabled() {
			const status = this.run_data()?.status
			return Boolean( this.task_title_draft().trim() && this.description_draft().trim() )
				&& ![ 'queued', 'running', 'waiting' ].includes( status ?? '' )
		}

		@ $mol_action
		override research( next?: Event ) {
			if( next === undefined ) return null
			this.task_action_start( 'research' )
			return next
		}

		@ $mol_action
		override work( next?: Event ) {
			if( next === undefined ) return null
			this.task_action_start( 'work' )
			return next
		}

		@ $mol_action
		override work_prerelease( next?: Event ) {
			if( next === undefined ) return null
			this.task_action_start( 'work_prerelease' )
			return next
		}

		@ $mol_action
		task_action_start( action: $shm_projects_task_action ) {
			if( !this.task_action_enabled() ) return null
			const current = this.task_data()
			const assignee_id = this.assignee_id_draft()
			const assignee_name = this.assignee_options()[ assignee_id ] || ''
			const assignee_profile_id = assignee_id.startsWith( 'name:' ) ? '' : assignee_id
			const change = {
				title: this.task_title_draft().trim(),
				description: this.description_draft().trim(),
				assignee_name,
				assignee_id: assignee_profile_id,
				priority: this.priority_draft() as $shm_projects_task_record['priority'],
				mode: action,
			}
			const revision = ( Number( current.revision ) || 0 ) + 1
			const key = `${ revision }:${ action }`
			const saved = this.action_payload( key, this.$.$shm_projects_task_update( this.project_id(), this.task_id(), { ...change, revision } ) )!
			this.task_data( saved )
			this.edit_opened( false )
			$mol_wire_async( this ).action_submit( key, action ).catch( $mol_fail_log )
			return saved
		}

		@ $mol_action
		action_submit( key: string, action: $shm_projects_task_action ) {
			const saved = this.action_payload( key )!
			const run = $mol_wire_sync( $shm_projects_goal_api ).task_run( this.project_id(), saved.legacy_id || this.task_id(), saved.run_id, saved.revision, saved, action )
			const started = this.$.$shm_projects_task_update( this.project_id(), this.task_id(), {
				run_id: run.id,
				status: run.status,
				mode: action,
			} )
			this.task_data( started )
			this.run_data( run )
			this.task_poll_schedule()
			this.agent_brought( false )
			this.agent_bring_schedule()
			return run
		}

		@ $mol_action
		override edit_cancel( next?: Event ) {
			if( next === undefined ) return null
			const task = this.task_data()
			this.task_title_draft( task.title )
			this.description_draft( task.description )
			this.assignee_id_draft( task.assignee_id || ( task.assignee_name ? `name:${ task.assignee_name }` : '' ) )
			this.priority_draft( task.priority )
			this.edit_opened( false )
			return next
		}

		@ $mol_action
		override edit_open( next?: Event ) {
			if( next === undefined ) return null
			this.edit_opened( true )
			return next
		}

		priority_meta() { return this.priority_options()[ this.task_data().priority || 'normal' ] }

		summary_action_rows() {
			return [ this.Edit_open() ]
		}

		summary_rows() {
			return [
				this.Task_meta(),
				this.Description_card(),
				...( this.task_result() ? [ this.Result_card() ] : [] ),
				this.Summary_actions(),
			]
		}

		task_description() { return this.task_data().description }

		summary_sections() {
			const source = String( this.run_data()?.summary || '' ).trim()
			return {
				result: source.match( /(?:^|\n)#{1,6}\s*Результат(?:ы)?\s*\n([\s\S]*)$/i )?.[1]?.trim() || this.task_data().result || ( this.run_data()?.status === 'done' ? source : '' ),
			}
		}

		task_result() { return this.summary_sections().result }

		@ $mol_mem
		message_draft( next?: string ) { return next ?? '' }

		send_message_enabled() {
			const status = this.run_data()?.status
			return Boolean( this.message_draft().trim() ) && status !== 'queued' && status !== 'running' && status !== 'waiting'
		}

		@ $mol_action
		override send_message( next?: Event ) {
			if( next === undefined ) return null
			const message = this.message_draft().trim()
			if( !message || !this.send_message_enabled() ) return next
			const run = $mol_wire_sync( $shm_projects_goal_api ).task_message( this.run_id(), message )
			this.message_draft( '' )
			this.task_data( this.$.$shm_projects_task_update( this.project_id(), this.task_id(), { status: run.status } ) )
			this.run_data( run )
			this.task_poll_schedule()
			return next
		}

		override destructor() {
			if( this.task_poll_timer ) clearTimeout( this.task_poll_timer )
			this.task_poll_timer = null
			super.destructor()
		}

		task_iteration() { return this.run_data()?.iteration ?? 0 }
		project_version() { return this.$.$shm_projects_data.version( this.project_id() ) }
		workspace_id() { return 'base' }

		agent_after() { return [] }

		task_pages() {
			const thinking = this.$.$mol_state_arg.value( 'project_thinking' )
			return [
				this.Details_page(),
				...( this.run_id() ? [ this.Agent().Chat_page() ] : [] ),
				...( this.run_id() && thinking ? [ this.Agent().Thinking() ] : [] ),
			]
		}

	}

}
